<div
    class="@container flex flex-col gap-4"
    [attr.aria-disabled]="disabled() ? true : null">
    <div class="flex flex-col @2xl:flex-row gap-4">
        <div
            class="drop-zone flex-1 text-center p-4 @md:p-6 rounded-lg @md:rounded-2xl flex flex-col items-center justify-center border-2 relative hover:border-primary-900"
            [class.border-dashed]="canDropNextFile()"
            [class.border-solid]="!canDropNextFile()"
            [class.border-primary-300]="!dragOver()"
            [class.border-primary-900]="dragOver()"
            [class.opacity-60]="!canDropNextFile()"
            [class.cursor-pointer]="canDropNextFile()"
            [class.pointer-events-none]="!canDropNextFile()"
            [class.drop-zone--inactive]="!canDropNextFile()"
            [attr.aria-disabled]="!canDropNextFile()"
            (dragover.prevent.stop)="onDragOver()"
            (dragleave.prevent.stop)="onDragLeave()"
            (drop.prevent.stop)="onDrop($event)">
            <div
                class="pointer-events-none flex flex-col items-center justify-center">
                <mat-icon class="mb-2 opacity-60" aria-hidden="true"
                    >file_upload</mat-icon
                >
                <span class="block font-semibold">{{
                    'shared.fileUploadDragDrop.dragDrop' | translate
                }}</span>
                <span class="block mt-1 text-sm opacity-70">{{
                    'shared.fileUploadDragDrop.or' | translate
                }}</span>
                <button
                    mat-stroked-button
                    color="accent"
                    type="button"
                    class="decorative-select-btn mt-2"
                    tabindex="-1"
                    aria-hidden="true">
                    {{ 'shared.fileUploadDragDrop.selectFile' | translate }}
                </button>
            </div>
            <input
                type="file"
                [accept]="acceptedFormats()"
                [multiple]="multiple()"
                [disabled]="!canDropNextFile()"
                (change)="upload($event.target, fileInput)"
                hidden
                #fileInput />
            <button
                type="button"
                class="drop-zone-overlay absolute inset-0 z-10 h-full w-full cursor-pointer bg-transparent disabled:cursor-not-allowed disabled:pointer-events-none"
                [disabled]="!canDropNextFile()"
                [attr.aria-label]="
                    'shared.fileUploadDragDrop.selectFile' | translate
                "
                (click)="fileInput.click()">
                <span class="sr-only">{{
                    'shared.fileUploadDragDrop.selectFile' | translate
                }}</span>
            </button>
        </div>
        @if (showRequirements()) {
            <aside
                class="@2xl:w-[40%] @md:min-w-[200px] shrink-0 rounded-lg @md:rounded-2xl p-4 border border-primary-300/50"
                aria-labelledby="file-upload-requirements-title">
                <h3
                    id="file-upload-requirements-title"
                    class="text-sm! uppercase mb-4">
                    {{
                        'shared.fileUploadDragDrop.requirements.title'
                            | translate
                    }}
                </h3>
                <ul
                    class="list-disc ms-[1.25em] space-y-1 text-sm marker:text-accent-500">
                    @for (item of requirementItems(); track $index) {
                        <li>{{ item }}</li>
                    }
                </ul>
            </aside>
        }
    </div>

    @if (files().length > 0) {
        <section
            class="rounded-lg @md:rounded-2xl border border-primary-300/50 p-4"
            aria-labelledby="file-upload-files-title"
            [attr.aria-busy]="isUploadInProgress() ? true : null">
            <header class="flex items-center justify-between gap-4 mb-4">
                <div class="flex items-center gap-2 min-w-0">
                    <h3
                        id="file-upload-files-title"
                        class="text-sm! uppercase shrink-0">
                        {{ 'shared.fileUploadDragDrop.tableLabel' | translate }}
                    </h3>
                    <span
                        class="rounded-full px-2 py-0.5 text-xs border border-primary-300/50 bg-primary-100 shrink-0"
                        aria-hidden="true">
                        {{ files().length }}
                    </span>
                    <span class="sr-only" aria-live="polite" aria-atomic="true">
                        {{
                            'shared.fileUploadDragDrop.filesCount'
                                | translate: { count: files().length }
                        }}
                    </span>
                </div>
                <button
                    type="button"
                    class="text-sm shrink-0 disabled:opacity-50 disabled:cursor-not-allowed"
                    attr.aria-label="{{
                        'shared.fileUploadDragDrop.clearAllVerbose' | translate
                    }}"
                    [disabled]="!canClearAllFiles()"
                    (click)="clearAllFiles()">
                    {{ 'shared.fileUploadDragDrop.clearAll' | translate }}
                </button>
            </header>

            <div class="overflow-auto max-h-56">
                <div class="min-w-[400px]">
                    <!-- deleteUiRevision: CD bridge for filesDeleting WeakMap (OnPush) -->
                    <apcam-files-table
                        [files]="files()"
                        [filesDeleting]="filesDeleting"
                        [deleteUiRevision]="deleteUiRevision()"
                        (onRemoveFile)="removeFile($event)" />
                </div>
            </div>
        </section>
    }

    <div class="flex justify-end">
        <apcam-tooltip-custom
            customMatTooltip="{{
                'shared.fileUploadDragDrop.uploadTooltip' | translate
            }}"
            [customMatTooltipDisabled]="allFilesUploadedInternal()">
            <button
                mat-flat-button
                color="primary"
                type="button"
                [attr.aria-busy]="submitButtonAriaBusy()"
                [attr.aria-label]="submitButtonAriaLabel()"
                [disabled]="!canSubmit()"
                [hidden]="hideSubmitButton()"
                (click)="submit()">
                <mat-icon>upload</mat-icon>
                {{ uploadButtonLabel() }}
                @if (showSubmitSpinner()) {
                    <mat-icon iconPositionEnd>
                        <apcam-loading-spinner size="xs" color="accent" />
                    </mat-icon>
                }
            </button>
        </apcam-tooltip-custom>
    </div>
</div>
